export default (context) => {

  const items = [
    {id: 2, name: 'Por grado / sección', onClick: (row, ctx, id) => {
      context.setState({selectedReport: id})
    }},
    {id: 1, name: 'Por profesor', onClick: (row, ctx, id) => {
      context.setState({selectedReport: id})
    }},
    {id: 5, name: 'Por curso', onClick: (row, ctx, id) => {
      context.setState({selectedReport: id})
    }},
    {id: 8, name: 'Por grupo', onClick: (row, ctx, id) => {
      context.setState({selectedReport: id})
    }},
    {id: 6, name: 'Conclusiones descriptivas', onClick: (row, ctx, id) => {
      context.setState({selectedReport: id})
    }},
    {id: 9, name: 'Conclusiones descriptivas por grupo', onClick: (row, ctx, id) => {
      context.setState({selectedReport: id})
    }},
    {id: 4, name: 'Notas finales', module:'admGradesRep', onClick: (row, ctx, id) => {
      context.setState({selectedReport: id})
    }},
    {id: 3, name: 'Notas finales Minedu', module:'admGradesRep', onClick: (row, ctx, id) => {
      context.setState({selectedReport: id})
    }},
    {id: 7, name: 'Ver todos los profesores', onClick: (row, ctx, id) => {
      context.toggleModal()
    }}
  ]

  const allowedItems = items.filter(f => { return !f.module || context.props.userAdmin.menu.some(s=> s.subs.some(ss=>ss.id === f.module))})

  return {
    extras: {
      items: allowedItems
    }
  }
}